import { routes } from "./routes.constatns";
import { Navigate, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import App from "../App";
import { Home, UserManagement } from "../components";
import DomainLayout from "./domain-layout";

function RequireHome({ children }) {
  const hasVisitedHome = useSelector((state) => state.landing.hasVisitedHome);
  if (!hasVisitedHome) return <Navigate to={`/${routes.home}`} replace />;
  return children;
}

export const AppRoutes = (
  <Route path={routes.root} element={<App />}>
    <>
      <Route index element={<Navigate to={`/${routes.home}`} />} />
      <Route path={routes.home} element={<Home />} />
      <Route
        path={routes.userManagement}
        element={
          <RequireHome>
            <UserManagement />
          </RequireHome>
        }
      />
      <Route path="/:domain/*" element={<DomainLayout />} />
    </>
  </Route>
);

export default AppRoutes;
